import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { WidgetContext } from "../../../main/layout/layout";
import { EffektButton, EffektButtonVariant } from "../EffektButton/EffektButton";
import { ctaButtonStyleOverrides } from "../../../main/layout/PageHeader/PageHeader";
import { usePlausible } from "next-plausible";
export const OpenWidgetButton: React.FC<{
  label?: string;
  accent_color?: string;
  cy?: string;
  causeAreaId?: number;
  organizationId?: number;
}> = t0 => {
  const $ = _c(16);
  const {
    label,
    accent_color,
    cy,
    causeAreaId,
    organizationId
  } = t0;
  const [, setWidgetContext] = useContext(WidgetContext);
  const plausible = usePlausible();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let giveButtonStyle = t1;
  if (accent_color) {
    let t2;
    if ($[1] !== accent_color) {
      t2 = {
        "--accent-color": accent_color
      };
      $[1] = accent_color;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    giveButtonStyle = t2 as React.CSSProperties;
  }
  const t2 = accent_color ? EffektButtonVariant.ACCENT : EffektButtonVariant.PRIMARY;
  let t3;
  if ($[3] !== causeAreaId || $[4] !== organizationId || $[5] !== plausible || $[6] !== setWidgetContext) {
    t3 = () => {
      setWidgetContext({
        open: true,
        prefilled: causeAreaId === undefined ? null : [{
          causeAreaId,
          share: 100,
          organizations: organizationId === undefined ? [] : [{
            organizationId,
            share: 100
          }]
        }],
        prefilledSum: null
      });
      plausible("OpenDonationWidget", {
        props: {
          page: window.location.pathname
        }
      });
      plausible("OpenDonationWidgetHeroCTA", {
        props: {
          page: window.location.pathname
        }
      });
    };
    $[3] = causeAreaId;
    $[4] = organizationId;
    $[5] = plausible;
    $[6] = setWidgetContext;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== giveButtonStyle) {
    t4 = {
      ...ctaButtonStyleOverrides,
      ...giveButtonStyle
    };
    $[8] = giveButtonStyle;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== cy || $[11] !== label || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <EffektButton cy={cy} variant={t2} onClick={t3} style={t4}>{label}</EffektButton>;
    $[10] = cy;
    $[11] = label;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};